import React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './PageContent.styles';

const useStyle = createUseStyles(styles, { name: 'PageContent' });
const PageContent = ({ children }) => {
  const classes = useStyle();
  return <div className={classes.contentWrapper}>{children}</div>;
};

export default PageContent;
